<app-header headerText="Lista De Préstamos Pendientes"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true>

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>timer</mat-icon>
      Pendientes<br>&nbsp;
    </ng-template>

    <h5 class="text-center">
      Lista de préstamos pendientes
    </h5>


    <div *ngIf="dataSource && dataSource.data && dataSource.data.length > 0; else emptyPending">

      <div class="row mt-4">

        <div class="col-md-12">

          <mat-table [dataSource]="dataSource" matSort class="table border">

            <ng-container matColumnDef="employeeNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeNumber}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="username">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.username }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="company">
              <mat-header-cell *matHeaderCellDef>Compañía</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.company }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="details" class="center-text">
              <mat-header-cell *matHeaderCellDef><span>Ver Información<br>Completa</span></mat-header-cell>
              <mat-cell *matCellDef="let element">

                <button mat-icon-button color="primary" [routerLink]="['employee-details', element.employeeNumber]">
                  <mat-icon aria-label="Download">accessibility</mat-icon>
                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>

        </div>

      </div>

      <div class="row mt-4" >

        <div class="col-lg-6 offset-lg-3 py-5 d-flex">

          <ul class="pagination mx-auto">
            <li *ngFor="let page of pages" class="page-item" [ngClass]="{'active': page === statePagination.currentRefinement}">
              <a class="page-link" (click)="statePaginationRefine(page)">
                {{page + 1}}
              </a>
            </li>
          </ul>

        </div>

      </div>

    </div>

    <ng-template #emptyPending>

      <div class="row mt-4">
        <div class="col-md-12 text-center noActions">
          <h5>No hay préstamos pendientes.</h5>
        </div>
      </div>

    </ng-template>



  </mat-tab>

</mat-tab-group>